
import $ from 'jquery';

export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function isMobile() {
    return $(window).width() < 992;
}

export function parseUrlParam(param) {
    var query = window.location.search.substring(1);
    var pair = [];
    var params = query.split('&');

    for (let i = 0; i < params.length; i++) {
        pair = params[i].split('=');

        if (decodeURIComponent(pair[0]) === param) {
            return decodeURIComponent(pair[1]);
        }
    }
}

export default {
    debounce,
    isMobile,
    parseUrlParam
};
